export default __webpack_public_path__ + "static/media/polygons-no-1.45da05e1.mid";